import { head, isEmpty, mapValues, pick } from 'lodash/fp';

import { Country, FormValues, PartialFieldNames } from '../../types';
import { FIELD_NAMES } from '../../../../constants';
import getCountriesBySearch from '../get-countries-by-search';

type GetFormValuesFromUrlParams = {
  countries: Country[];
  destinationLocation?: string;
  queryStringValues: PartialFieldNames;
  initialValues: PartialFieldNames;
};

const convertToBoolean = (value: string) => {
  if (value === 'true') return true;
  if (value === 'false') return false;
  return value;
};

const getFormValuesFromUrl = ({
  countries,
  destinationLocation,
  queryStringValues = {},
  initialValues,
}: GetFormValuesFromUrlParams): PartialFieldNames | null => {
  if (isEmpty(countries)) {
    return null;
  }
  const formFieldNames = Object.values(FIELD_NAMES);
  const convertedQueryStringValues = mapValues(convertToBoolean, queryStringValues);
  const widgetValuesFromQuery = pick(formFieldNames, convertedQueryStringValues) as PartialFieldNames;
  const whereField = FIELD_NAMES.WHERE as keyof FormValues;
  const whereSearchTerm = destinationLocation || (widgetValuesFromQuery[whereField] as string);
  const whereSearchTermWithoutHyphen = whereSearchTerm?.replace('-', ' ');
  const destinationCountry = head(getCountriesBySearch(countries, whereSearchTermWithoutHyphen));
  const valuesFormattedToMatchForm = destinationCountry
    ? {
        [FIELD_NAMES.WHERE]: destinationCountry.label,
        [FIELD_NAMES.DESTINATIONS]: destinationCountry.value,
      }
    : {};
  return { ...initialValues, ...widgetValuesFromQuery, ...valuesFormattedToMatchForm };
};

export default getFormValuesFromUrl;
